import type { Countries } from './countries.type';

export const COUNTRIES: Countries = {
  AF: { label: 'Afghanistan (‫افغانستان‬‎)', id: 'AF', isoCode: 'AF', dialCode: '+93' },
  AL: { label: 'Albania (Shqipëri)', id: 'AL', isoCode: 'AL', dialCode: '+355' },
  DZ: { label: 'Algeria (‫الجزائر‬‎)', id: 'DZ', isoCode: 'DZ', dialCode: '+213' },
  AS: { label: 'American Samoa', id: 'AS', isoCode: 'AS', dialCode: '+1684' },
  AD: { label: 'Andorra', id: 'AD', isoCode: 'AD', dialCode: '+376' },
  AO: { label: 'Angola', id: 'AO', isoCode: 'AO', dialCode: '+244' },
  AI: { label: 'Anguilla', id: 'AI', isoCode: 'AI', dialCode: '+1264' },
  AG: { label: 'Antigua and Barbuda', id: 'AG', isoCode: 'AG', dialCode: '+1268' },
  AR: { label: 'Argentina', id: 'AR', isoCode: 'AR', dialCode: '+54' },
  AM: { label: 'Armenia (Հայաստան)', id: 'AM', isoCode: 'AM', dialCode: '+374' },
  AN: { label: 'Netherlands (Antilles)', id: 'AN', isoCode: 'AN', dialCode: '+599' },
  AW: { label: 'Aruba', id: 'AW', isoCode: 'AW', dialCode: '+297' },
  AU: { label: 'Australia', id: 'AU', isoCode: 'AU', dialCode: '+61' },
  AT: { label: 'Austria (Österreich)', id: 'AT', isoCode: 'AT', dialCode: '+43' },
  AZ: { label: 'Azerbaijan (Azərbaycan)', id: 'AZ', isoCode: 'AZ', dialCode: '+994' },
  BS: { label: 'Bahamas', id: 'BS', isoCode: 'BS', dialCode: '+1242' },
  BH: { label: 'Bahrain (‫البحرين‬‎)', id: 'BH', isoCode: 'BH', dialCode: '+973' },
  BD: { label: 'Bangladesh (বাংলাদেশ)', id: 'BD', isoCode: 'BD', dialCode: '+880' },
  BB: { label: 'Barbados', id: 'BB', isoCode: 'BB', dialCode: '+1246' },
  BY: { label: 'Belarus (Беларусь)', id: 'BY', isoCode: 'BY', dialCode: '+375' },
  BE: { label: 'Belgium (België)', id: 'BE', isoCode: 'BE', dialCode: '+32' },
  BZ: { label: 'Belize', id: 'BZ', isoCode: 'BZ', dialCode: '+501' },
  BJ: { label: 'Benin (Bénin)', id: 'BJ', isoCode: 'BJ', dialCode: '+229' },
  BM: { label: 'Bermuda', id: 'BM', isoCode: 'BM', dialCode: '+1441' },
  BT: { label: 'Bhutan (འབྲུག)', id: 'BT', isoCode: 'BT', dialCode: '+975' },
  BO: { label: 'Bolivia', id: 'BO', isoCode: 'BO', dialCode: '+591' },
  BA: {
    label: 'Bosnia and Herzegovina (Босна и Херцеговина)',
    id: 'BA',
    isoCode: 'BA',
    dialCode: '+387',
  },
  BW: { label: 'Botswana', id: 'BW', isoCode: 'BW', dialCode: '+267' },
  BR: { label: 'Brazil (Brasil)', id: 'BR', isoCode: 'BR', dialCode: '+55' },
  IO: { label: 'British Indian Ocean Territory', id: 'IO', isoCode: 'IO', dialCode: '+246' },
  VG: { label: 'British Virgin Islands', id: 'VG', isoCode: 'VG', dialCode: '+1284' },
  BN: { label: 'Brunei', id: 'BN', isoCode: 'BN', dialCode: '+673' },
  BG: { label: 'Bulgaria (България)', id: 'BG', isoCode: 'BG', dialCode: '+359' },
  BF: { label: 'Burkina Faso', id: 'BF', isoCode: 'BF', dialCode: '+226' },
  BI: { label: 'Burundi (Uburundi)', id: 'BI', isoCode: 'BI', dialCode: '+257' },
  KH: { label: 'Cambodia (កម្ពុជា)', id: 'KH', isoCode: 'KH', dialCode: '+855' },
  CM: { label: 'Cameroon (Cameroun)', id: 'CM', isoCode: 'CM', dialCode: '+237' },
  CA: { label: 'Canada', id: 'CA', isoCode: 'CA', dialCode: '+1' },
  CV: { label: 'Cape Verde (Kabu Verdi)', id: 'CV', isoCode: 'CV', dialCode: '+238' },
  KY: { label: 'Cayman Islands', id: 'KY', isoCode: 'KY', dialCode: '+1345' },
  CF: {
    label: 'Central African Republic (République centrafricaine)',
    id: 'CF',
    isoCode: 'CF',
    dialCode: '+236',
  },
  TD: { label: 'Chad (Tchad)', id: 'TD', isoCode: 'TD', dialCode: '+235' },
  CL: { label: 'Chile', id: 'CL', isoCode: 'CL', dialCode: '+56' },
  CN: { label: 'China (中国)', id: 'CN', isoCode: 'CN', dialCode: '+86' },
  CX: { label: 'Christmas Island', id: 'CX', isoCode: 'CX', dialCode: '+61' },
  CC: { label: 'Cocos (Keeling) Islands', id: 'CC', isoCode: 'CC', dialCode: '+61' },
  CO: { label: 'Colombia', id: 'CO', isoCode: 'CO', dialCode: '+57' },
  KM: { label: 'Comoros (‫جزر القمر‬‎)', id: 'KM', isoCode: 'KM', dialCode: '+269' },
  CD: {
    label: 'Congo (DRC) (Jamhuri ya Kisoemokrasia ya Kongo)',
    id: 'CD',
    isoCode: 'CD',
    dialCode: '+243',
  },
  CG: {
    label: 'Congo (Republic) (Congo-Brazzaville)',
    id: 'CG',
    isoCode: 'CG',
    dialCode: '+242',
  },
  CK: { label: 'Cook Islands', id: 'CK', isoCode: 'CK', dialCode: '+682' },
  CR: { label: 'Costa Rica', id: 'CR', isoCode: 'CR', dialCode: '+506' },
  CI: { label: "Côte d'Ivoire", id: 'CI', isoCode: 'CI', dialCode: '+225' },
  HR: { label: 'Croatia (Hrvatska)', id: 'HR', isoCode: 'HR', dialCode: '+385' },
  CU: { label: 'Cuba', id: 'CU', isoCode: 'CU', dialCode: '+53' },
  CW: { label: 'Curaçao', id: 'CW', isoCode: 'CW', dialCode: '+599' },
  CY: { label: 'Cyprus (Κύπρος)', id: 'CY', isoCode: 'CY', dialCode: '+357' },
  CZ: { label: 'Czech Republic (Česká republika)', id: 'CZ', isoCode: 'CZ', dialCode: '+420' },
  DK: { label: 'Denmark (Danmark)', id: 'DK', isoCode: 'DK', dialCode: '+45' },
  DJ: { label: 'Djibouti', id: 'DJ', isoCode: 'DJ', dialCode: '+253' },
  DM: { label: 'Dominica', id: 'DM', isoCode: 'DM', dialCode: '+1767' },
  DO: {
    label: 'Dominican Republic (República Dominicana)',
    id: 'DO',
    isoCode: 'DO',
    dialCode: '+1',
  },
  EC: { label: 'Ecuador', id: 'EC', isoCode: 'EC', dialCode: '+593' },
  EG: { label: 'Egypt (‫مصر‬‎)', id: 'EG', isoCode: 'EG', dialCode: '+20' },
  SV: { label: 'El Salvador', id: 'SV', isoCode: 'SV', dialCode: '+503' },
  GQ: {
    label: 'Equatorial Guinea (Guinea Ecuatorial)',
    id: 'GQ',
    isoCode: 'GQ',
    dialCode: '+240',
  },
  ER: { label: 'Eritrea', id: 'ER', isoCode: 'ER', dialCode: '+291' },
  EE: { label: 'Estonia (Eesti)', id: 'EE', isoCode: 'EE', dialCode: '+372' },
  ET: { label: 'Ethiopia', id: 'ET', isoCode: 'ET', dialCode: '+251' },
  FK: { label: 'Falkland Islands (Islas Malvinas)', id: 'FK', isoCode: 'FK', dialCode: '+500' },
  FO: { label: 'Faroe Islands (Føroyar)', id: 'FO', isoCode: 'FO', dialCode: '+298' },
  FJ: { label: 'Fiji', id: 'FJ', isoCode: 'FJ', dialCode: '+679' },
  FI: { label: 'Finland (Suomi)', id: 'FI', isoCode: 'FI', dialCode: '+358' },
  FR: { label: 'France', id: 'FR', isoCode: 'FR', dialCode: '+33' },
  GF: { label: 'French Guiana (Guyane française)', id: 'GF', isoCode: 'GF', dialCode: '+594' },
  PF: {
    label: 'French Polynesia (Polynésie française)',
    id: 'PF',
    isoCode: 'PF',
    dialCode: '+689',
  },
  GA: { label: 'Gabon', id: 'GA', isoCode: 'GA', dialCode: '+241' },
  GM: { label: 'Gambia', id: 'GM', isoCode: 'GM', dialCode: '+220' },
  GE: { label: 'Georgia (საქართველო)', id: 'GE', isoCode: 'GE', dialCode: '+995' },
  DE: { label: 'Germany (Deutschland)', id: 'DE', isoCode: 'DE', dialCode: '+49' },
  GH: { label: 'Ghana (Gaana)', id: 'GH', isoCode: 'GH', dialCode: '+233' },
  GI: { label: 'Gibraltar', id: 'GI', isoCode: 'GI', dialCode: '+350' },
  GR: { label: 'Greece (Ελλάδα)', id: 'GR', isoCode: 'GR', dialCode: '+30' },
  GL: { label: 'Greenland (Kalaallit Nunaat)', id: 'GL', isoCode: 'GL', dialCode: '+299' },
  GD: { label: 'Grenada', id: 'GD', isoCode: 'GD', dialCode: '+1473' },
  GP: { label: 'Guadeloupe', id: 'GP', isoCode: 'GP', dialCode: '+590' },
  GU: { label: 'Guam', id: 'GU', isoCode: 'GU', dialCode: '+1671' },
  GT: { label: 'Guatemala', id: 'GT', isoCode: 'GT', dialCode: '+502' },
  GG: { label: 'Guernsey', id: 'GG', isoCode: 'GG', dialCode: '+44' },
  GN: { label: 'Guinea (Guinée)', id: 'GN', isoCode: 'GN', dialCode: '+224' },
  GW: { label: 'Guinea-Bissau (Guiné Bissau)', id: 'GW', isoCode: 'GW', dialCode: '+245' },
  GY: { label: 'Guyana', id: 'GY', isoCode: 'GY', dialCode: '+592' },
  HT: { label: 'Haiti', id: 'HT', isoCode: 'HT', dialCode: '+509' },
  HN: { label: 'Honduras', id: 'HN', isoCode: 'HN', dialCode: '+504' },
  HK: { label: 'Hong Kong (香港)', id: 'HK', isoCode: 'HK', dialCode: '+852' },
  HU: { label: 'Hungary (Magyarország)', id: 'HU', isoCode: 'HU', dialCode: '+36' },
  IS: { label: 'Iceland (Ísland)', id: 'IS', isoCode: 'IS', dialCode: '+354' },
  IN: { label: 'India (भारत)', id: 'IN', isoCode: 'IN', dialCode: '+91' },
  ID: { label: 'Indonesia', id: 'ID', isoCode: 'ID', dialCode: '+62' },
  IR: { label: 'Iran (‫ایران‬‎)', id: 'IR', isoCode: 'IR', dialCode: '+98' },
  IQ: { label: 'Iraq (‫العراق‬‎)', id: 'IQ', isoCode: 'IQ', dialCode: '+964' },
  IE: { label: 'Ireland', id: 'IE', isoCode: 'IE', dialCode: '+353' },
  IM: { label: 'Isle of Man', id: 'IM', isoCode: 'IM', dialCode: '+44' },
  IL: { label: 'Israel (‫ישראל‬‎)', id: 'IL', isoCode: 'IL', dialCode: '+972' },
  IT: { label: 'Italy (Italia)', id: 'IT', isoCode: 'IT', dialCode: '+39' },
  JM: { label: 'Jamaica', id: 'JM', isoCode: 'JM', dialCode: '+1' },
  JP: { label: 'Japan (日本)', id: 'JP', isoCode: 'JP', dialCode: '+81' },
  JE: { label: 'Jersey', id: 'JE', isoCode: 'JE', dialCode: '+44' },
  JO: { label: 'Jordan (‫الأردن‬‎)', id: 'JO', isoCode: 'JO', dialCode: '+962' },
  KZ: { label: 'Kazakhstan (Казахстан)', id: 'KZ', isoCode: 'KZ', dialCode: '+7' },
  KE: { label: 'Kenya', id: 'KE', isoCode: 'KE', dialCode: '+254' },
  KI: { label: 'Kiribati', id: 'KI', isoCode: 'KI', dialCode: '+686' },
  XK: { label: 'Kosovo', id: 'XK', isoCode: 'XK', dialCode: '+383' },
  KW: { label: 'Kuwait (‫الكويت‬‎)', id: 'KW', isoCode: 'KW', dialCode: '+965' },
  KG: { label: 'Kyrgyzstan (Кыргызстан)', id: 'KG', isoCode: 'KG', dialCode: '+996' },
  LA: { label: 'Laos (ລາວ)', id: 'LA', isoCode: 'LA', dialCode: '+856' },
  LV: { label: 'Latvia (Latvija)', id: 'LV', isoCode: 'LV', dialCode: '+371' },
  LB: { label: 'Lebanon (‫لبنان‬‎)', id: 'LB', isoCode: 'LB', dialCode: '+961' },
  LS: { label: 'Lesotho', id: 'LS', isoCode: 'LS', dialCode: '+266' },
  LR: { label: 'Liberia', id: 'LR', isoCode: 'LR', dialCode: '+231' },
  LY: { label: 'Libya (‫ليبيا‬‎)', id: 'LY', isoCode: 'LY', dialCode: '+218' },
  LI: { label: 'Liechtenstein', id: 'LI', isoCode: 'LI', dialCode: '+423' },
  LT: { label: 'Lithuania (Lietuva)', id: 'LT', isoCode: 'LT', dialCode: '+370' },
  LU: { label: 'Luxembourg', id: 'LU', isoCode: 'LU', dialCode: '+352' },
  MO: { label: 'Macau (澳門)', id: 'MO', isoCode: 'MO', dialCode: '+853' },
  MK: {
    label: 'North Macedonia (FYROM) (Македонија)',
    id: 'MK',
    isoCode: 'MK',
    dialCode: '+389',
  },
  MG: { label: 'Madagascar (Madagasikara)', id: 'MG', isoCode: 'MG', dialCode: '+261' },
  MW: { label: 'Malawi', id: 'MW', isoCode: 'MW', dialCode: '+265' },
  MY: { label: 'Malaysia', id: 'MY', isoCode: 'MY', dialCode: '+60' },
  MV: { label: 'Maldives', id: 'MV', isoCode: 'MV', dialCode: '+960' },
  ML: { label: 'Mali', id: 'ML', isoCode: 'ML', dialCode: '+223' },
  MT: { label: 'Malta', id: 'MT', isoCode: 'MT', dialCode: '+356' },
  MH: { label: 'Marshall Islands', id: 'MH', isoCode: 'MH', dialCode: '+692' },
  MQ: { label: 'Martinique', id: 'MQ', isoCode: 'MQ', dialCode: '+596' },
  MR: { label: 'Mauritania (‫موريتانيا‬‎)', id: 'MR', isoCode: 'MR', dialCode: '+222' },
  MU: { label: 'Mauritius (Moris)', id: 'MU', isoCode: 'MU', dialCode: '+230' },
  YT: { label: 'Mayotte', id: 'YT', isoCode: 'YT', dialCode: '+262' },
  MX: { label: 'Mexico (México)', id: 'MX', isoCode: 'MX', dialCode: '+52' },
  FM: { label: 'Micronesia', id: 'FM', isoCode: 'FM', dialCode: '+691' },
  MD: { label: 'Moldova (Republica Moldova)', id: 'MD', isoCode: 'MD', dialCode: '+373' },
  MC: { label: 'Monaco', id: 'MC', isoCode: 'MC', dialCode: '+377' },
  MN: { label: 'Mongolia (Монгол)', id: 'MN', isoCode: 'MN', dialCode: '+976' },
  ME: { label: 'Montenegro (Crna Gora)', id: 'ME', isoCode: 'ME', dialCode: '+382' },
  MS: { label: 'Montserrat', id: 'MS', isoCode: 'MS', dialCode: '+1664' },
  MA: { label: 'Morocco (‫المغرب‬‎)', id: 'MA', isoCode: 'MA', dialCode: '+212' },
  MZ: { label: 'Mozambique (Moçambique)', id: 'MZ', isoCode: 'MZ', dialCode: '+258' },
  MM: { label: 'Myanmar (Burma) (မြန်မာ)', id: 'MM', isoCode: 'MM', dialCode: '+95' },
  NA: { label: 'Namibia (Namibië)', id: 'NA', isoCode: 'NA', dialCode: '+264' },
  NR: { label: 'Nauru', id: 'NR', isoCode: 'NR', dialCode: '+674' },
  NP: { label: 'Nepal (नेपाल)', id: 'NP', isoCode: 'NP', dialCode: '+977' },
  NL: { label: 'Netherlands (Nederland)', id: 'NL', isoCode: 'NL', dialCode: '+31' },
  NC: { label: 'New Caledonia (Nouvelle-Calédonie)', id: 'NC', isoCode: 'NC', dialCode: '+687' },
  NZ: { label: 'New Zealand', id: 'NZ', isoCode: 'NZ', dialCode: '+64' },
  NI: { label: 'Nicaragua', id: 'NI', isoCode: 'NI', dialCode: '+505' },
  NE: { label: 'Niger (Nijar)', id: 'NE', isoCode: 'NE', dialCode: '+227' },
  NG: { label: 'Nigeria', id: 'NG', isoCode: 'NG', dialCode: '+234' },
  NU: { label: 'Niue', id: 'NU', isoCode: 'NU', dialCode: '+683' },
  NF: { label: 'Norfolk Island', id: 'NF', isoCode: 'NF', dialCode: '+672' },
  KP: {
    label: 'North Korea (조선 민주주의 인민 공화국)',
    id: 'KP',
    isoCode: 'KP',
    dialCode: '+850',
  },
  MP: { label: 'Northern Mariana Islands', id: 'MP', isoCode: 'MP', dialCode: '+1670' },
  NO: { label: 'Norway (Norge)', id: 'NO', isoCode: 'NO', dialCode: '+47' },
  OM: { label: 'Oman (‫عُمان‬‎)', id: 'OM', isoCode: 'OM', dialCode: '+968' },
  PK: { label: 'Pakistan (‫پاکستان‬‎)', id: 'PK', isoCode: 'PK', dialCode: '+92' },
  PW: { label: 'Palau', id: 'PW', isoCode: 'PW', dialCode: '+680' },
  PS: { label: 'Palestine (‫فلسطين‬‎)', id: 'PS', isoCode: 'PS', dialCode: '+970' },
  PA: { label: 'Panama (Panamá)', id: 'PA', isoCode: 'PA', dialCode: '+507' },
  PG: { label: 'Papua New Guinea', id: 'PG', isoCode: 'PG', dialCode: '+675' },
  PY: { label: 'Paraguay', id: 'PY', isoCode: 'PY', dialCode: '+595' },
  PE: { label: 'Peru (Perú)', id: 'PE', isoCode: 'PE', dialCode: '+51' },
  PH: { label: 'Philippines', id: 'PH', isoCode: 'PH', dialCode: '+63' },
  PL: { label: 'Poland (Polska)', id: 'PL', isoCode: 'PL', dialCode: '+48' },
  PT: { label: 'Portugal', id: 'PT', isoCode: 'PT', dialCode: '+351' },
  PR: { label: 'Puerto Rico', id: 'PR', isoCode: 'PR', dialCode: '+1' },
  QA: { label: 'Qatar (‫قطر‬‎)', id: 'QA', isoCode: 'QA', dialCode: '+974' },
  RE: { label: 'Réunion (La Réunion)', id: 'RE', isoCode: 'RE', dialCode: '+262' },
  RO: { label: 'Romania (România)', id: 'RO', isoCode: 'RO', dialCode: '+40' },
  RU: { label: 'Russia (Россия)', id: 'RU', isoCode: 'RU', dialCode: '+7' },
  RW: { label: 'Rwanda', id: 'RW', isoCode: 'RW', dialCode: '+250' },
  BL: { label: 'Saint Barthélemy', id: 'BL', isoCode: 'BL', dialCode: '+590' },
  SH: { label: 'Saint Helena', id: 'SH', isoCode: 'SH', dialCode: '+290' },
  KN: { label: 'Saint Kitts and Nevis', id: 'KN', isoCode: 'KN', dialCode: '+1869' },
  LC: { label: 'Saint Lucia', id: 'LC', isoCode: 'LC', dialCode: '+1758' },
  MF: {
    label: 'Saint Martin (Saint-Martin (partie française))',
    id: 'MF',
    isoCode: 'MF',
    dialCode: '+590',
  },
  PM: {
    label: 'Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)',
    id: 'PM',
    isoCode: 'PM',
    dialCode: '+508',
  },
  VC: { label: 'Saint Vincent and the Grenadines', id: 'VC', isoCode: 'VC', dialCode: '+1784' },
  WS: { label: 'Samoa', id: 'WS', isoCode: 'WS', dialCode: '+685' },
  SM: { label: 'San Marino', id: 'SM', isoCode: 'SM', dialCode: '+378' },
  ST: {
    label: 'São Tomé and Príncipe (São Tomé e Príncipe)',
    id: 'ST',
    isoCode: 'ST',
    dialCode: '+239',
  },
  SA: {
    label: 'Saudi Arabia (‫المملكة العربية السعودية‬‎)',
    id: 'SA',
    isoCode: 'SA',
    dialCode: '+966',
  },
  SN: { label: 'Senegal (Sénégal)', id: 'SN', isoCode: 'SN', dialCode: '+221' },
  RS: { label: 'Serbia (Србија)', id: 'RS', isoCode: 'RS', dialCode: '+381' },
  SC: { label: 'Seychelles', id: 'SC', isoCode: 'SC', dialCode: '+248' },
  SL: { label: 'Sierra Leone', id: 'SL', isoCode: 'SL', dialCode: '+232' },
  SG: { label: 'Singapore', id: 'SG', isoCode: 'SG', dialCode: '+65' },
  SX: { label: 'Sint Maarten', id: 'SX', isoCode: 'SX', dialCode: '+1721' },
  SK: { label: 'Slovakia (Slovensko)', id: 'SK', isoCode: 'SK', dialCode: '+421' },
  SI: { label: 'Slovenia (Slovenija)', id: 'SI', isoCode: 'SI', dialCode: '+386' },
  SB: { label: 'Solomon Islands', id: 'SB', isoCode: 'SB', dialCode: '+677' },
  SO: { label: 'Somalia (Soomaaliya)', id: 'SO', isoCode: 'SO', dialCode: '+252' },
  ZA: { label: 'South Africa', id: 'ZA', isoCode: 'ZA', dialCode: '+27' },
  KR: { label: 'South Korea (대한민국)', id: 'KR', isoCode: 'KR', dialCode: '+82' },
  SS: { label: 'South Sudan (‫جنوب السودان‬‎)', id: 'SS', isoCode: 'SS', dialCode: '+211' },
  ES: { label: 'Spain (España)', id: 'ES', isoCode: 'ES', dialCode: '+34' },
  LK: { label: 'Sri Lanka (ශ්‍රී ලංකාව)', id: 'LK', isoCode: 'LK', dialCode: '+94' },
  SD: { label: 'Sudan (‫السودان‬‎)', id: 'SD', isoCode: 'SD', dialCode: '+249' },
  SR: { label: 'Suriname', id: 'SR', isoCode: 'SR', dialCode: '+597' },
  SJ: { label: 'Svalbard and Jan Mayen', id: 'SJ', isoCode: 'SJ', dialCode: '+47' },
  SZ: { label: 'Swaziland', id: 'SZ', isoCode: 'SZ', dialCode: '+268' },
  SE: { label: 'Sweden (Sverige)', id: 'SE', isoCode: 'SE', dialCode: '+46' },
  CH: { label: 'Switzerland (Schweiz)', id: 'CH', isoCode: 'CH', dialCode: '+41' },
  SY: { label: 'Syria (‫سوريا‬‎)', id: 'SY', isoCode: 'SY', dialCode: '+963' },
  TW: { label: 'Taiwan (台灣)', id: 'TW', isoCode: 'TW', dialCode: '+886' },
  TJ: { label: 'Tajikistan', id: 'TJ', isoCode: 'TJ', dialCode: '+992' },
  TZ: { label: 'Tanzania', id: 'TZ', isoCode: 'TZ', dialCode: '+255' },
  TH: { label: 'Thailand (ไทย)', id: 'TH', isoCode: 'TH', dialCode: '+66' },
  TL: { label: 'Timor-Leste', id: 'TL', isoCode: 'TL', dialCode: '+670' },
  TG: { label: 'Togo', id: 'TG', isoCode: 'TG', dialCode: '+228' },
  TK: { label: 'Tokelau', id: 'TK', isoCode: 'TK', dialCode: '+690' },
  TO: { label: 'Tonga', id: 'TO', isoCode: 'TO', dialCode: '+676' },
  TT: { label: 'Trinisoad and Tobago', id: 'TT', isoCode: 'TT', dialCode: '+1868' },
  TN: { label: 'Tunisia (‫تونس‬‎)', id: 'TN', isoCode: 'TN', dialCode: '+216' },
  TR: { label: 'Turkey (Türkiye)', id: 'TR', isoCode: 'TR', dialCode: '+90' },
  TM: { label: 'Turkmenistan', id: 'TM', isoCode: 'TM', dialCode: '+993' },
  TC: { label: 'Turks and Caicos Islands', id: 'TC', isoCode: 'TC', dialCode: '+1649' },
  TV: { label: 'Tuvalu', id: 'TV', isoCode: 'TV', dialCode: '+688' },
  VI: { label: 'U.S. Virgin Islands', id: 'VI', isoCode: 'VI', dialCode: '+1340' },
  UG: { label: 'Uganda', id: 'UG', isoCode: 'UG', dialCode: '+256' },
  UA: { label: 'Ukraine (Україна)', id: 'UA', isoCode: 'UA', dialCode: '+380' },
  AE: {
    label: 'United Arab Emirates (‫الإمارات العربية المتحدة‬‎)',
    id: 'AE',
    isoCode: 'AE',
    dialCode: '+971',
  },
  GB: { label: 'United Kingdom', id: 'GB', isoCode: 'GB', dialCode: '+44' },
  US: { label: 'United States', id: 'US', isoCode: 'US', dialCode: '+1' },
  UY: { label: 'Uruguay', id: 'UY', isoCode: 'UY', dialCode: '+598' },
  UZ: { label: 'Uzbekistan (Oʻzbekiston)', id: 'UZ', isoCode: 'UZ', dialCode: '+998' },
  VU: { label: 'Vanuatu', id: 'VU', isoCode: 'VU', dialCode: '+678' },
  VA: { label: 'Vatican City (Città del Vaticano)', id: 'VA', isoCode: 'VA', dialCode: '+39' },
  VE: { label: 'Venezuela', id: 'VE', isoCode: 'VE', dialCode: '+58' },
  VN: { label: 'Vietnam (Việt Nam)', id: 'VN', isoCode: 'VN', dialCode: '+84' },
  WF: {
    label: 'Wallis and Futuna (Wallis-et-Futuna)',
    id: 'WF',
    isoCode: 'WF',
    dialCode: '+681',
  },
  YE: { label: 'Yemen (‫اليمن‬‎)', id: 'YE', isoCode: 'YE', dialCode: '+967' },
  ZM: { label: 'Zambia', id: 'ZM', isoCode: 'ZM', dialCode: '+260' },
  ZW: { label: 'Zimbabwe', id: 'ZW', isoCode: 'ZW', dialCode: '+263' },
  AX: { label: 'Åland Islands', id: 'AX', isoCode: 'AX', dialCode: '+358' },
};
